import { makeStyles, alpha } from '@material-ui/core';
export default makeStyles(function (theme) {
  var _theme$palette, _theme$palette$defaul, _ledgerIcon;

  return {
    root: {},
    listIcons: {
      zIndex: 2,
      width: '100%',
      maxWidth: 400,
      marginTop: '2rem',
      '& $listItem + $listItem': {
        marginTop: theme.spacing(1)
      }
    },
    listItem: {
      border: "1px solid " + alpha(theme.palette.primary.light, 0.2),
      borderRadius: 6
    },
    ledgerIcon: (_ledgerIcon = {
      width: '4rem',
      height: '4rem',
      verticalAlign: 'middle'
    }, _ledgerIcon["width"] = '6rem', _ledgerIcon.fill = theme === null || theme === void 0 ? void 0 : (_theme$palette = theme.palette) === null || _theme$palette === void 0 ? void 0 : (_theme$palette$defaul = _theme$palette.default) === null || _theme$palette$defaul === void 0 ? void 0 : _theme$palette$defaul.contrastText, _ledgerIcon.padding = '0.5rem', _ledgerIcon),
    iconText: {
      '& span': {
        fontSize: '1.5rem'
      }
    }
  };
});